import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { store } from "../../redux/oldStore.tsx";
import { toast } from "react-toastify";
import NhdNav from "../Layout/NhdNav";

function siteLabel(s) {
  const state = (s && (s.stateName || s.state)) || "";
  const name = (s && s.name) || "Contest";
  return state ? `${state} — ${name}` : name;
}

export default function CompleteInvite() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [message, setMessage] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [done, setDone] = useState(false);
  const [user, setUser] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) {
      setMessage("This invite link is not valid.");
      return;
    }
    store.server
      .getApi(`Users/InviteInfo?token=${encodeURIComponent(token)}`)
      .then((r) => {
        if (r && r.Value && r.Value.valid) {
          setInfo(r.Value);
        } else {
          setInfo(r && r.Value ? r.Value : { valid: false, resent: r && r.Value && r.Value.resent });
          setMessage((r && r.Message) || "This invite link is not valid.");
        }
      })
      .catch(() => setMessage("Could not load this invite."));
  }, [token]);

  const submit = () => {
    if (!password || password.length < 8) {
      toast.info("Please choose a password that is at least 8 characters.");
      return;
    }
    if (password !== password2) {
      toast.info("Passwords do not match.");
      return;
    }
    setBusy(true);
    store.server
      .postApi("Users/CompleteInvite", { token, password })
      .then((r) => {
        setBusy(false);
        if (r && r.Success) {
          setDone(true);
          setUser(r.Value);
        } else {
          toast.error((r && r.Message) || "Could not complete invite.", {
            autoClose: false,
          });
          if (r && r.Value && r.Value.resent) {
            setInfo({ valid: false, resent: true });
            setMessage(r.Message);
          }
        }
      })
      .catch(() => {
        setBusy(false);
        toast.error("Could not complete invite.");
      });
  };

  return (
    <div className="nhd-page">
      <NhdNav user={user} onAuthChange={() => {}} />
      <div className="nhd-page-body">
        <h1>Complete your invite</h1>
        {done && (
          <div className="alert bg-success">
            <p>Password saved. You are signed in.</p>
            <Link className="btn-primary" to="/app/Contests">
              Find contests
            </Link>
          </div>
        )}
        {!done && info && info.valid && (
          <>
            <p>
              Welcome{info.firstName ? `, ${info.firstName}` : ""}. Set a password
              for <strong>{info.email}</strong>.
            </p>
            <p>
              Security level: <strong>{info.securityLevel}</strong>
            </p>
            <p>
              Contest access:{" "}
              {(info.sites || []).length
                ? info.sites.map(siteLabel).join("; ")
                : "None assigned yet"}
            </p>
            <div className="form-input">
              <label htmlFor="inv-pass">New password</label>
              <input
                id="inv-pass"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                onKeyDown={(e) => e.key === "Enter" && submit()}
              />
            </div>
            <div className="form-input">
              <label htmlFor="inv-pass2">Confirm</label>
              <input
                id="inv-pass2"
                type="password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                autoComplete="new-password"
                onKeyDown={(e) => e.key === "Enter" && submit()}
              />
            </div>
            <button
              type="button"
              className="btn-primary"
              disabled={busy}
              onClick={submit}
            >
              {busy ? "Saving…" : "Save password"}
            </button>
          </>
        )}
        {!done && (!info || !info.valid) && message && (
          <div className={`alert ${info && info.resent ? "bg-info" : "bg-warning"}`}>
            <h3>{info && info.resent ? "New invite sent" : "Invite not available"}</h3>
            <p>{message}</p>
          </div>
        )}
      </div>
    </div>
  );
}
